import _ from 'lodash'

const notifications = {
	namespaced: true,
	state: {
		since: (localStorage.getItem('notificationSince')) ? localStorage.getItem('notificationSince') : '',
		noteSince: (localStorage.getItem('noteNotificationSince')) ? localStorage.getItem('noteNotificationSince') : '',
		messages: [],
		notes: [],
		messagesGroupedByPageId: {}
	},
	getters: {
		getNoteNotificationSince(state){
			return state.noteSince
		},
		getNotificationSince(state){
			return state.since
		},
		getNotificationMessages(state){
			return state.messages
		},
		getNotificationNotes(state){
			return state.notes
		},
		getNotificationMessagesGroupedByPageId(state){
			return state.messagesGroupedByPageId
		}
	},
	mutations: {
		setNotificationSince(state, since){
			localStorage.setItem('notificationSince', since);
			state.since = localStorage.getItem('notificationSince')
		},
		setNoteNotificationSince(state, since){
			localStorage.setItem('noteNotificationSince', since);
			state.noteSince = localStorage.getItem('noteNotificationSince')
		},
		setConcatNotificationMessages(state, messages){
			let messagesBeforeMadeUnique = messages.concat(state.messages);
			state.messages = _.uniqBy(messagesBeforeMadeUnique, function (e) {
				return e.documentKey._id;
			  });
		},
		setNotificationMessages(state, messages){
			state.messages = messages
		},
		setNotificationNotes(state, notes){
			state.notes = notes
		},
		setConcatNotificationNotes(state, notes){
			state.notes = notes.concat(state.notes)
		},
		setNotificationMessagesGroupedByPageId(state){
			state.messagesGroupedByPageId = _.groupBy(state.messages, 'fullDocument.page')
		}
	},
	actions: {
		setNotificationSince({ commit }, since){
			commit('setNotificationSince', since)
	},
		setNoteNotificationSince({ commit }, since){
			commit('setNoteNotificationSince', since)
	},
		setNotificationMessages({ commit }, messages){
			commit('setNotificationMessages', messages)
	},
		setNotificationNotes({ commit }, notes){
			commit('setNotificationNotes', notes)
	},
		setConcatNotificationNotes({ commit }, notes){
			commit('setConcatNotificationNotes', notes)
	},
		setConcatNotificationMessages({ commit }, messages){
			commit('setConcatNotificationMessages', messages)
	},
	setNotificationMessagesGroupedByPageId({ commit }, messages){
			commit('setNotificationMessagesGroupedByPageId', messages)
	}
}
}

export default notifications;


// WEBPACK FOOTER //
// ./src/store/notifications.js